import moment from 'moment';
import type { Moment } from '../lib/moment';

export interface MailBounceEntryResponse {
  user_id: number;
  user_name: string;
  organization_id: number;
  organization_name: string;
  email: string;
  reason: string;
  bounced_at: string;
}

class MailBounceEntry {
  userId: number;
  userName: string;
  organizationId: number;
  organizationName: string;
  email: string;
  reason: string;
  bouncedAt: Moment;

  constructor(args: MailBounceEntryResponse) {
    this.userId = args.user_id;
    this.userName = args.user_name;
    this.organizationId = args.organization_id;
    this.organizationName = args.organization_name;
    this.email = args.email;
    this.reason = args.reason;
    this.bouncedAt = moment(args.bounced_at);
  }
}

export default MailBounceEntry;
